import PropTypes from 'prop-types'
import Modal from '@/components/Modal'
import CardConfigure from '@/components/Modal/CardConfigure'
import Button from '@/components/Button'
import RedInfoIcon from '@/assets/svgs/red-info-icon.svg?react'

const REJECT_REASON_MAX = 1000

export const RejectModal = ({ visible, onClose, onConfirm, rejectReason, setRejectReason }) => (
  <Modal visible={visible} close={onClose} variant="small" dataTestId="submittal-reject-modal">
    <CardConfigure>
      <CardConfigure.Header>
        <CardConfigure.Header.Title>
          <div className="flex items-center w-full">
            <div className="flex items-center">
              <div className="bg-red-95 text-red-50 [&_svg]:w-6.5 [&_svg]:h-6.5">
                <RedInfoIcon />
              </div>
              <div className="ml-4">
                <div className="font-avenir-heavy type-header-4 text-grey-30">Reject Request</div>
              </div>
            </div>
          </div>
        </CardConfigure.Header.Title>
      </CardConfigure.Header>
      <CardConfigure.Body>
        <CardConfigure.Body.Col>
          <p className="font-avenir-medium type-body-2 text-grey-40 mb-0 text-center">
            This action will deny data sharing to the designated recipient. Proceed anyway?
          </p>
          <div className="mt-5">
            <div className="flex items-center gap-0.5 font-avenir-medium type-meta-medium text-grey-50 mb-2">
              <span className="text-red-50">*</span>
              Reject Reason
            </div>
            <textarea
              className="w-full box-border resize-none border border-grey-90 rounded-lg p-3 font-avenir-medium type-body-2 text-grey-30 outline-none transition-[border-color] duration-150 placeholder:text-grey-80 focus:border-theme-50"
              rows={4}
              maxLength={REJECT_REASON_MAX}
              placeholder="Enter Text Here"
              value={rejectReason}
              onChange={e => setRejectReason(e.target.value)}
            />
            <div className="flex justify-between items-start mt-1">
              <div className="font-avenir-medium type-meta-medium text-grey-50">
                Describe reject reason here
              </div>
              <div className="font-avenir-medium type-meta-medium text-grey-50 text-right">
                {rejectReason.length}/{REJECT_REASON_MAX}
              </div>
            </div>
          </div>
        </CardConfigure.Body.Col>
      </CardConfigure.Body>
      <CardConfigure.Footer>
        <CardConfigure.Footer.Left>
          <Button
            data-testid="submittal-reject-cancel-btn"
            round
            btnText
            textWarning
            onClick={onClose}
          >
            Cancel
          </Button>
        </CardConfigure.Footer.Left>
        <CardConfigure.Footer.Right>
          <Button
            data-testid="submittal-reject-confirm-btn"
            round
            error
            disabled={rejectReason.trim().length === 0}
            onClick={onConfirm}
          >
            Confirm
          </Button>
        </CardConfigure.Footer.Right>
      </CardConfigure.Footer>
    </CardConfigure>
  </Modal>
)

RejectModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  rejectReason: PropTypes.string.isRequired,
  setRejectReason: PropTypes.func.isRequired,
}
